{
  "common": {
    "loading": "Loading…"
  },
  "dashboard": {
    "title": "Trends",
    "activeProfile": "Active athlete"
  },
  "activity": {
    "title": "Activity",
    "empty": "No activity recorded today yet.",
    "steps": "Steps",
    "activeKcal": "Active kcal",
    "restingKcal": "Resting kcal",
    "feedsNote": "These three feed the expenditure side of your energy balance. Nutrition reads them directly.",
    "openNutrition": "Open Nutrition"
  },
  "recovery": {
    "title": "Recovery",
    "subtitle": "HRV {{start}} → {{end}} · Stress {{today}}",
    "hrvHistory": "HRV history",
    "stressToday": "Stress today"
  },
  "sleep": {
    "title": "Sleep",
    "empty": "No sleep records yet for the last 7 days.",
    "duration": "{{hours}} h {{minutes}} m",
    "durationNotRecorded": "Duration not recorded",
    "score": "Score {{score}}"
  },
  "weight": {
    "title": "Weight",
    "empty": "No weight records yet for the last 90 days.",
    "bodyComposition": "Body composition (latest)",
    "feedsNote": "This weight is what Nutrition uses to back-calculate your maintenance, and what your power-to-weight is computed against."
  },
  "hrv": {
    "empty": "No HRV records yet."
  },
  "stress": {
    "empty": "No stress episodes recorded today.",
    "avgPeak": "Avg {{avg}} · Peak {{peak}}"
  },
  "nav": {
    "ariaLabel": "Health detail pages",
    "sleep": "Sleep",
    "recovery": "Recovery",
    "weight": "Weight",
    "activity": "Activity",
    "trends": "Trends",
    "labs": "Labs"
  },
  "source": {
    "fallbackActive": "Fallback active"
  },
  "trends": {
    "date": "Date",
    "metricsLegend": "Metrics",
    "rangeAria": "Date range",
    "selectMetric": "Select at least one metric to see its trend.",
    "metric": {
      "sleep": "Sleep",
      "hrv": "HRV",
      "weight": "Weight",
      "steps": "Steps"
    },
    "range": {
      "d30": "30d",
      "d90": "90d",
      "d365": "1y"
    }
  },
  "addData": "Add data",
  "wellnessEntry": {
    "title": "Add wellness for {{date}}",
    "titleNoDate": "Add wellness",
    "weight": "Weight",
    "sleepHours": "Sleep hours",
    "sleepScore": "Sleep score",
    "bedtime": "Bedtime",
    "wakeTime": "Wake time",
    "hrv": "HRV",
    "steps": "Steps",
    "save": "Save",
    "importFile": "Import a file",
    "importHint": "Imported files use their own date.",
    "error": {
      "invalidHours": "Enter the hours slept as h:mm, for example 7:30.",
      "invalidScore": "Enter a sleep score from 0 to 100.",
      "needsDuration": "Enter the hours slept, or both bedtime and wake time.",
      "mismatch": "The hours slept don't match the bedtime and wake time."
    }
  }
}
